import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCategoryListAction } from '../../../redux/modules/category'

export default function useCategories() {
  const dispatch = useDispatch()
  const categories = useSelector((state) => state.category?.categories || [])

  useEffect(() => {
    dispatch(getCategoryListAction())
  }, [dispatch])

  const categoryOptions = useMemo(() => {
    if (!categories || categories.length === 0) return []

    return categories.map((category) => ({
      value: category.id,
      label: category.name,
      ...category,
    }))
  }, [categories])

  return {
    categories,
    categoryOptions,
  }
}
